<script setup lang="ts">
/**
 * Main app layout for components that are included via our SPA setup,
 * where Twig doesn't take care of adding header/footer.
 */

import LeHeader from "@dsk/components/Header/LeHeader.vue";
import { storeToRefs } from "pinia";

import LeSiteBanner from "@/components/banners/LeSiteBanner.vue";
import LeFooter from "@/components/LeFooter.vue";
import { useUserStore } from "@/stores";

interface Props {
  simpleFooter?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  simpleFooter: false
});

const { userData, isEnterpriseAdmin, isEnterpriseDictionaryEditor } = storeToRefs(useUserStore());
</script>

<template>
  <LeSiteBanner />

  <div class="le-layout-main">
    <LeHeader
      :company-name="userData.companyName"
      :username="userData.username"
      :network-name="userData.credentials.openNetwork.name"
      :is-authenticated="userData.credentials.authenticated"
      :is-network="userData.credentials.openNetwork.active"
      :is-paying="userData.paying"
      :is-enterprise-admin="isEnterpriseAdmin"
      :is-enterprise-dictionary-editor="isEnterpriseDictionaryEditor"
      :user-type="userData.credentials.type"
    />

    <slot />

    <LeFooter class="le-layout-main__footer" :simple="props.simpleFooter" />
  </div>
</template>

<style lang="less" scoped>
.le-layout-main {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__footer {
    margin-top: auto;
  }
}
</style>
